<template>
  <portal
    :to="portalName"
  >
    <div
      ref="parent"
      :class="[
        $style.right_popup,
        $style.bottom_border,
        borderTop ? $style.top_border : '',
        show && withAnimation ? $style.show_right_popup_animated : '',
        show && !withAnimation ? $style.show_right_popup : '',
        show && withAnimation && customRightPositionHistory ? $style.show_right_popup_animated_history :'',
        show && withAnimation && customRightPositionExport ? $style.show_right_popup_animated_export : '',
        customRightPositionHistory || customRightPositionExport ? $style.right_popup_second : ''
      ] "
      :style="{...styles, width: width+'px'}"
    >
      <slot name="body" />
    </div>
  </portal>
</template>

<script>

export default {
  name: 'RightPopup',
  components: { },
  props: {
    show: { type: Boolean, required: false, default: false },
    width: { type: Number, required: false, default: 300 },
    excludeFooter: { type: Boolean, required: false, default: false },
    excludeHeader: { type: Boolean, required: false, default: false },
    excludeHeaderToolbar: { type: Boolean, required: false, default: false },
    borderTop: { type: Boolean, required: false, default: true },
    borderLeft: { type: Boolean, required: false, default: true },
    customHeaderHeigth: { type: Number, required: false, default: null },
    portalName: { type: String, default: 'right-popup' },
    withAnimation: { type: Boolean, default: true },
    customStyles: { type: Object, required: false, default: () => {} },
    customRightPositionHistory: { type: Boolean, required: false, default: false },
    customRightPositionExport: { type: Boolean, required: false, default: false },
  },

  data() {
    return {
      popupHeight: 0,
      styles: {},
    };
  },

  computed: {
    headerHeight() {
      if (this.customHeaderHeigth) {
        return this.customHeaderHeigth;
      }

      return this.$store ? this.$store.getters['headerView/height'] || 0 : 0;
    },

    headerToolbarHeigh() {
      return 40;
    },

    footerHeight() {
      return 0;
    },

  },

  watch: {
    show() {
      this.calcStyles();
    },
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
    this.$nextTick(this.calcStyles);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize() {
      this.calcStyles();
    },

    calcStyles() {
      let top = 0;
      let bottom = 0;
      const clientHeight = document.documentElement.clientHeight;
      let borderLeft = '1px solid  #D9D9D9';

      if (this.excludeHeaderToolbar) {
        const borderTopHeight = this.borderTop ? 1 : 0;

        top = this.headerHeight - this.headerToolbarHeigh - borderTopHeight;
      }

      if (this.excludeHeader) {
        top = this.headerHeight;
      }

      if (this.excludeFooter) {
        bottom = this.footerHeight - 1;
      }

      if (!this.borderLeft) {
        // borderLeft = '1px solid transparent';
        borderLeft = 'none';
      }

      this.styles = {
        top: `${top}px`,
        bottom: `${bottom}px`,
        borderLeft,
        ...this.customStyles,
      };

      const height = `${clientHeight - bottom - parseFloat(this.styles.top)}px`;

      this.styles = {
        ...this.styles,
        height,
      };
    },
  },
};
</script>

 <style module lang="less">

.right_popup{
  position: fixed;
  right: -100%;
  // z-index: 50;
  z-index: 31;
  min-width: 200px;
  background-color: #ffffff;
  box-shadow: -20px 0px 22px -22px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  font-family: Lato-Regular, sans-serif;
  overflow: hidden;
  transition: right .6s;

  &.show_right_popup{
    right: 0;
  }

  &.show_right_popup_animated {
    right: 0;
  }
  &.show_right_popup_animated_history {
    right: 401px !important;

    &::before {
      border-top-color: #F2F2F2 !important;
    }
  }
  &.show_right_popup_animated_export {
    right: 301px !important;

    &::before {
      border-top-color: #F2F2F2 !important;
    }
  }

  &.bottom_border:after,
  &.top_border:before {
    display: block;
    content: '';
    position: absolute;
    height: 1px;
    width: 100%;
  }

  &.bottom_border:after{
    bottom: 0;
    border-bottom: 1px solid #D9D9D9;
  }

  &.top_border:before{
    top: 0;
    border-top: 1px solid #D9D9D9;
    z-index: 2;
  }
  &_second {
    // z-index: 7 !important;
    z-index: 99999;
  }
}

 </style>
